import axios from 'axios'
import store from '../store/index'

export function loginAuth(token, user) {
    window.$cookies.set("token", token, 0, null, process.env.VUE_APP_DOMAIN);
    window.$cookies.set("id", user.id, 0, null, process.env.VUE_APP_DOMAIN);

    localStorage.user = JSON.stringify(user.attributes)

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

export function logoutAuth() {
    window.$cookies.remove("token", null, process.env.VUE_APP_DOMAIN);
    window.$cookies.remove("token");
    window.$cookies.remove("id", null, process.env.VUE_APP_DOMAIN);

    localStorage.removeItem("user")

    store.dispatch('resetState');
    
    if(localStorage.space){
        var spaceData = JSON.parse(localStorage.space)
        spaceData.role = "NA"
        localStorage.space = JSON.stringify(spaceData)
    }
    
    var arrayCookie = []
    for (var i = 0; i < window.$cookies.keys().length; i++) {
        var cookie = window.$cookies.keys()[i].trim();
        // If the prefix of the cookie's name matches the one specified, remove it
        if (cookie.includes('activity-feed-state')) {
            arrayCookie.push(cookie)
        }
    }
    arrayCookie.forEach(cookie => window.$cookies.remove(cookie, null, process.env.VUE_APP_DOMAIN))
}

export function loginSaml(token) {
    window.$cookies.remove("token", null, process.env.VUE_APP_DOMAIN);
    window.$cookies.remove("token");
    window.$cookies.set("token", token, 0, null, process.env.VUE_APP_DOMAIN);

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}
